import { inferHoldLevel } from "./eventStatus";

type HoldSource = {
  status: string;
  hold_level?: number | null;
};

/** Prefer API hold_level when present; otherwise infer from status string. */
export function resolveHoldLevel(event: HoldSource): number | null {
  const level = event.hold_level;
  if (typeof level === "number" && level >= 1 && level <= 3) return level;
  return inferHoldLevel(event.status);
}
